import { createAsyncAction, createReducer} from 'typesafe-actions'
import { put, call, takeEvery, all } from 'redux-saga/effects';
import * as api from '../lib/api/subscriber'
import { getSubscribersInfoState, subscribersInfoPayloadType, getPaidLogsPayloadType } from '../pages/types';
import { getSubscriberRequestDTO, updateSubscriberRequestDTO } from '../lib/api/types';
import { updateSubscribers } from './updateSubscribers'
import { getPaidLogs } from './getPaidLogs';
import { AxiosError } from 'axios';


export const getSubscribersInfo = createAsyncAction(
  'GET_SUBSCRIBERS_INFO',
  'GET_SUBSCRIBERS_INFO_SUCCESS',
  'GET_SUBSCRIBERS_INFO_FAILURE',
)<getSubscriberRequestDTO, any, AxiosError>();

type subscribersInfoAction = ReturnType<typeof getSubscribersInfo.request>

const initialState: getSubscribersInfoState = {
  data:{
    denyUrl:'',
    name:'',
    type:'S',
    email: "",
    fields: [],
    paidLogs: [],
    status: "R",
    paymentMethod:{
      cardName:'',
      cardNumber:'',
      lastUsedDate:'',
      paymentOption:''
    },
    paidTotalCount:0,
    payment:{
      currentItemCode: 0,
      firstPaidTime: 0,
      nextItemCode: 0,
      payingPrice: 0,
      recentPaidTime:0,
      renewalDate: "",
      subscriptionType: "",
    },
  },
  loading:false,
  error:false,
}

export function* getSubscribersInfoSaga(action:subscribersInfoAction):Generator{
  try {
    const response:any = yield call(
      api.getSubscriber,
      action.payload
    )
    yield put(getSubscribersInfo.success(response.data))
  } catch (e) {
    yield put(getSubscribersInfo.failure(e))
  }
}

export function* subscribersInfoSaga(){
  yield all([takeEvery(getSubscribersInfo.request, getSubscribersInfoSaga)])
}

export const subscribersInfo = createReducer<
  getSubscribersInfoState,
  ReturnType<typeof getSubscribersInfo.request>|
  ReturnType<typeof getSubscribersInfo.success>|
  ReturnType<typeof getSubscribersInfo.failure>|
  ReturnType<typeof getPaidLogs.request>|
  ReturnType<typeof getPaidLogs.success>|
  ReturnType<typeof getPaidLogs.failure>|
  ReturnType<typeof updateSubscribers.request>|
  ReturnType<typeof updateSubscribers.success>|
  ReturnType<typeof updateSubscribers.failure>
>(initialState)
  .handleAction(
    getSubscribersInfo.request,
    (state:getSubscribersInfoState, action:{payload:getSubscriberRequestDTO}
      )=>({
        ...state,
        loading:true,
        error:false,
        status:'request'
      })
  )
  .handleAction(
    getSubscribersInfo.success,
    (state:getSubscribersInfoState,action:{payload:subscribersInfoPayloadType})=>({
      ...state,
      loading:false,
      data:action.payload,
      status:'success'
    })
  ).handleAction(
    getSubscribersInfo.failure,
    (state:getSubscribersInfoState,action:{payload:AxiosError})=>({
      ...state,
      loading:false,
      error:true,
      errorData:action.payload,
      status:'failure'
    })
  )
  .handleAction(
    updateSubscribers.request,
    (state:getSubscribersInfoState, action:{payload:updateSubscriberRequestDTO}
      )=>({
        ...state,
        loading:true,
        error:false,
        status:'request'
      })
  )
  .handleAction(
    updateSubscribers.success,
    (state:getSubscribersInfoState,action:{payload:subscribersInfoPayloadType})=>({
      ...state,
      loading:false,
      data:action.payload,
      status:'success'
    })
  ).handleAction(
    updateSubscribers.failure,
    (state:getSubscribersInfoState,action:{payload:AxiosError})=>({
      ...state,
      loading:false,
      error:true,
      errorData:action.payload,
      status:'failure'
    })
  )
  .handleAction(
    getPaidLogs.request,
    (state:getSubscribersInfoState, action:{payload:getSubscriberRequestDTO})=>({
      ...state,
      loading:true,
      error:false,
    })
  )
  .handleAction(
    getPaidLogs.success,
    (state:getSubscribersInfoState, action:{payload:getPaidLogsPayloadType})=>({
      ...state,
        data:{...state.data,
          paidLogs:action.payload.items
        },
        loading:false,
        error:false,
      }
    )
  )
  .handleAction(
    getPaidLogs.failure,
    (state:getSubscribersInfoState,action:{payload:Error})=>({
      ...state,
      loading:false,
      error:true,
    })
  )


export default subscribersInfo